import { render, staticRenderFns } from "./updateContentsModal.vue?vue&type=template&id=85535db0&scoped=true&"
import script from "./updateContentsModal.vue?vue&type=script&lang=js&"
export * from "./updateContentsModal.vue?vue&type=script&lang=js&"
import style0 from "./updateContentsModal.vue?vue&type=style&index=0&id=85535db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85535db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85535db0')) {
      api.createRecord('85535db0', component.options)
    } else {
      api.reload('85535db0', component.options)
    }
    module.hot.accept("./updateContentsModal.vue?vue&type=template&id=85535db0&scoped=true&", function () {
      api.rerender('85535db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/modal/updateContentsModal.vue"
export default component.exports